//Author June Leow
//Date Mar 25th, 2024
import {generateTooltip} from '../../../../util/util';
import {Col, Row} from 'reactstrap';
import MySelect from '../../../util/my-select';
import React, {useEffect} from 'react';

const heatingTypeEnum = [
  {value:'CENTRAL_HOT_AIR', label:'Central Hot Air'},
  {value:'HOT_WATER_RADIATORS', label:'Hot Water Radiators'},
  {value:'HOT_WATER_BASEBOARD', label:'Hot Water Baseboard'},
  {value:'ELECTRIC_BASEBOARD', label:'Electric Baseboard'},
  {value:'IN_WALL_HEATER', label:'In Wall Heater'},
  {value:'RADIANT_FLOOR', label:'Radiant Floor'},
  {value:'CENTRAL_HEATPUMP', label:'Central Heatpump'},
  {value:'DUCTLESS_HEATPUMP', label:'Ductless Heatpump'},
  {value:'DUCTLESS_HEAT', label:'Ductless Heat'},
  {value:'GEOTHERMAL', label:'Geothermal'},
  {value:'WALL_FURNACE', label:'Wall Furnace'},
  {value:'GAS_FURNACE', label:'Gas Furnace'},
  {value:'OIL_FURNACE', label:'Oil Furnace'},
  {value:'COAL_FURNACE', label:'Coal Furnace'},
  {value:'NO_HEAT', label:'No Heat'}
]
 
const coolingTypeEnum = [
  {value:'CENTRAL_AIR_CONDITIONING', label:'Central Air Conditioning'},
  {value:'CENTRAL_HEATPUMP', label:'Central Heatpump'},
  {value:'DUCTLESS_HEATPUMP', label:'Ductless Heatpump'},
  {value:'DUCTLESS_AIR_CONDITIONING', label:'Ductless Air Conditioning'},
  {value:'WHOLE_HOUSE_FAN', label:'Whole House Fan'},
  {value:'EVAPORATIVE_COOLER', label:'Evaporative Cooler'},
  {value:'GEOTHERMAL', label:'Geothermal'},
  {value:'NONE', label:'None'},
]

const disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};


//reducer function that perform state update

const HeatingCoolings  = (props)=>{
  const controller = new AbortController();

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const getHeatingTypeLabel = (value)=>{
    for(let i=0;i<heatingTypeEnum.length;i++){
      if(heatingTypeEnum[i].value===value)
        return heatingTypeEnum[i].label;
    }

    return value;
  }

  const getCoolingTypeLabel = (value)=>{
    for(let i=0;i<coolingTypeEnum.length;i++){
      if(coolingTypeEnum[i].value===value)
        return coolingTypeEnum[i].label;
    }

    return value;
  }

  const updateCoolingType = (value)=>{
    let newUPD = Object.assign({}, props.upd);
    let coolingSystems = newUPD.property.buildings[props.index].units[props.index2].coolingSystems?newUPD.property.buildings[props.index].units[props.index2].coolingSystems.slice():null;
    
    
    if(value==='NONE'){
      coolingSystems = [{coolingType:'NONE'}];
    }
    else{
      let index = coolingSystems.map(function(e) { return e.coolingType; }).indexOf('NONE');
      if(index!==-1){
        coolingSystems = [{coolingType:value}];
      }
      else{
        let index = coolingSystems.map(function(e) { return e.coolingType; }).indexOf(value);
        if(index===-1)
          coolingSystems.push({coolingType:value});
      }
    }
    
    newUPD.property.buildings[props.index].units[props.index2].coolingSystems = coolingSystems;
    props.update(newUPD);
  }

  const updateHeatingType = (value)=>{
    let newUPD = Object.assign({}, props.upd);
    let heatingSystems = newUPD.property.buildings[props.index].units[props.index2].heatingSystems?newUPD.property.buildings[props.index].units[props.index2].heatingSystems.slice():null;
    
    if(value==='NO_HEAT'){
      heatingSystems = [{heatingType:'NO_HEAT'}];
    }
    else{
      let index = heatingSystems.map(function(e) { return e.heatingType; }).indexOf('NO_HEAT');
      if(index!==-1){
        heatingSystems = [{heatingType:value}];
      }
      else{
        let index = heatingSystems.map(function(e) { return e.heatingType; }).indexOf(value);
        if(index===-1)
        heatingSystems.push({heatingType:value});
      }
    }
    
    newUPD.property.buildings[props.index].units[props.index2].heatingSystems = heatingSystems;
    props.update(newUPD);
  }

  const removeCoolingType = (index)=>{
    let newUPD = Object.assign({}, props.upd);
    let coolingSystems = newUPD.property.buildings[props.index].units[props.index2].coolingSystems?newUPD.property.buildings[props.index].units[props.index2].coolingSystems.slice():null;
    coolingSystems.splice(index, 1);
    newUPD.property.buildings[props.index].units[props.index2].coolingSystems = coolingSystems;
    props.update(newUPD);
  }

  const removeHeatingType = (index)=>{
    let newUPD = Object.assign({}, props.upd);
    let heatingSystems = newUPD.property.buildings[props.index].units[props.index2].heatingSystems?newUPD.property.buildings[props.index].units[props.index2].heatingSystems.slice():null;
    heatingSystems.splice(index, 1);
    newUPD.property.buildings[props.index].units[props.index2].heatingSystems = heatingSystems;
    props.update(newUPD);
  }

  //API call

  //render
  return <div>
    <Row>
      <Col sm="6">
        <label>{!props.disabled?<font color="red">*</font>:null}Indicate all heating systems for each unit. {generateTooltip('heatingType', 'User to select the best option to identify each heating system for each structure unit. If the structure unit has no heat source, the user must select the \'No Heat\' option.')}</label>
        <MySelect
          type="select"
          required={!props.disabled}
          disabled={props.disabled}
          style={props.disabled?disabledStyling:{}}
          value={props.upd.property.buildings[props.index].units[props.index2].heatingSystems && props.upd.property.buildings[props.index].units[props.index2].heatingSystems.length>0?" ":""}
          onChange={(v)=>updateHeatingType(v)}
          options={heatingTypeEnum}
        />
        {
          props.upd.property.buildings[props.index].units[props.index2].heatingSystems.map(
            (heatingType, index2)=>{
              return <span className="my-badge3" key={index2} style={{marginRight:'5px', padding:'10px'}}>
                <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeHeatingType(index2)}/> {getHeatingTypeLabel(heatingType.heatingType)}
              </span>
            }
          )
        }
      </Col>
      <Col sm="6">
        <label>{!props.disabled?<font color="red">*</font>:null}Indicate all cooling systems for each unit. {generateTooltip('coolingType', 'Indicate all cooling systems for each unit. If there are multiple systems, chose all that apply.  If there is no cooling, "None" must be selected. ')}</label>
        <MySelect
          type="select"
          required={!props.disabled}
          disabled={props.disabled}
          style={props.disabled?disabledStyling:{}}
          value={props.upd.property.buildings[props.index].units[props.index2].coolingSystems && props.upd.property.buildings[props.index].units[props.index2].coolingSystems.length>0?" ":""}
          onChange={(v)=>updateCoolingType(v)}
          options={coolingTypeEnum}
        />
        {
          props.upd.property.buildings[props.index].units[props.index2].coolingSystems.map(
            (coolingType, index2)=>{
              return <span className="my-badge3" key={index2} style={{marginRight:'5px', padding:'10px'}}>
                <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeCoolingType(index2)}/> {getCoolingTypeLabel(coolingType.coolingType)}
              </span>
            }
          )
      }
      </Col>
    </Row>
  </div>
}


export default HeatingCoolings;